"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingFacade = exports.TrackingEventAction = void 0;
var TrackingEventAction;
(function (TrackingEventAction) {
    TrackingEventAction[TrackingEventAction["VWBasic_Layer_Load"] = 0] = "VWBasic_Layer_Load";
    TrackingEventAction[TrackingEventAction["VWBasic_Button_Click"] = 1] = "VWBasic_Button_Click";
    TrackingEventAction[TrackingEventAction["VWBasic_Screen_Load"] = 2] = "VWBasic_Screen_Load";
    TrackingEventAction[TrackingEventAction["VWBasic_GenericFeatureApp_Load"] = 3] = "VWBasic_GenericFeatureApp_Load";
    TrackingEventAction[TrackingEventAction["VWBasic_ErrorMessage_Load"] = 4] = "VWBasic_ErrorMessage_Load";
    TrackingEventAction[TrackingEventAction["VWBasic_Link_Click"] = 5] = "VWBasic_Link_Click";
    TrackingEventAction[TrackingEventAction["VWBasic_BackendCall_Result"] = 6] = "VWBasic_BackendCall_Result";
    TrackingEventAction[TrackingEventAction["VWBasic_Download_Click"] = 7] = "VWBasic_Download_Click";
})(TrackingEventAction || (exports.TrackingEventAction = TrackingEventAction = {}));
class TrackingFacade {
    constructor(localeService, trackingService, loggingFacade, authService) {
        this.localeService = localeService;
        this.trackingService = trackingService;
        this.loggingFacade = loggingFacade;
        this.authService = authService;
        this.applicationId = 'VWLocalMyVolkswagenD6';
    }
    async pushEvent(trackingEvent) {
        try {
            const trackingData = await this.createTrackingData(trackingEvent);
            this.trackingService.track(TrackingEventAction[trackingEvent.action], trackingData);
        }
        catch (e) {
            this.loggingFacade.error('TrackingFacade - pushing event failed.', e);
        }
    }
    async createTrackingData(trackingEvent) {
        const isAuthenticated = this.authService ? await this.authService.isAuthenticated() : false;
        const trackingData = {
            eventInfo: {
                contentId: trackingEvent.contentId,
                pageName: trackingEvent.pageName,
                sectionName: trackingEvent.sectionName
            },
            environment: {
                applicationId: this.applicationId,
                language: this.localeService.language,
                country: this.localeService.countryCode
            },
            user: {
                loginStatus: isAuthenticated
            }
        };
        if ([TrackingEventAction.VWBasic_Button_Click, TrackingEventAction.VWBasic_Link_Click,
            TrackingEventAction.VWBasic_Download_Click].includes(trackingEvent.action)) {
            trackingData.link = { name: trackingEvent.contentId, url: this.getPageId() };
        }
        if (trackingEvent.action === TrackingEventAction.VWBasic_ErrorMessage_Load) {
            trackingData.error = Object.assign(Object.assign({}, trackingEvent.error), { referringUrl: window.location.href });
        }
        return trackingData;
    }
    // Implementation is taken from: https://github.com/volkswagen-onehub/tracking-service/blob/master/src/v1/index.ts
    getPageId() {
        return `${window.location.host}${window.location.pathname}`;
    }
}
exports.TrackingFacade = TrackingFacade;
//# sourceMappingURL=TrackingFacade.js.map